<template>
  <content-page :page-slug="parentSlug" :parent-link="parentLink">
    <chapter-nav-links></chapter-nav-links>
    <h1 class="content-page__title" v-html="pageTitle" />
    <div class="content-page__html" v-html="pageContent"></div>
    <chapter-nav-links class="chapter-nav-links--bottom"></chapter-nav-links>
  </content-page>
</template>

<script>
function isMenuPage(menuData, name) {
  const urls = [];
  if (menuData) {
    menuData.reduce((acc, val) => {
      urls.push(val.url);
      if (val.childItems) {
        const childUrls = val.childItems.map((obj) => obj.url);
        childUrls.forEach((url) => urls.push(url));
      }
    }, urls);
    if (!urls.find((url) => url.endsWith(`${name}/`))) {
      return true;
    }
  }
  return false;
}

import { get } from "lodash";
import { last as vlast } from "voca";
import GetInsidePage from "~/apollo/queries/getInsidePage";
import ContentPage from "~/components/ContentPage/ContentPage";
import ChapterNavLinks from "~/components/ContentPage/ChapterNavLinks";
import PopoutUtilities from "~/utilities/PopoutUtilities";
import GetChapterPage from "~/apollo/queries/getChapterPage";
import slugify from "slugify";

export default {
  components: {
    ContentPage,
    ChapterNavLinks,
  },

  layout({ route, store }) {
    const slug = route.params.pathMatch;
    const siteMenuData = store.state.menu.siteMenuData;
    if (isMenuPage(siteMenuData, slug)) {
      return "insidepage";
    } else {
      return "chapter";
    }
  },

  data() {
    return {
      url: JSON.stringify(this.$route.params),
      slug: null,
    };
  },

  async fetch({ params, app, error, store }) {
    try {
      let response = await app.apolloProvider.defaultClient.query({
        query: GetChapterPage,
        fetchPolicy: "network-only",
        variables: {
          uri: params.chap,
        },
      });
      const chapter = response.data.pageBy;
      store.commit("chapter/setCurrentChapter", chapter);

      let urlPath = params.pathMatch;
      if (vlast(urlPath, 1) === "/") {
        urlPath = urlPath.slice(0, -1);
      }
      const slug = `${params.chap}/${urlPath}`;
      response = await app.apolloProvider.defaultClient.query({
        query: GetInsidePage,
        fetchPolicy: "network-only",
        variables: {
          uri: slug,
        },
      });
      const page = response.data.page;
      store.commit("chapter/setInsidePage", page);

      // set prevPage/nextPage urls
      let prevUrl = "",
        nextUrl = "";
      const siteMenuItem = store.state.menu.siteMenuData.find(
        (menuItem) => menuItem.pageId === chapter.pageId
      );
      if (siteMenuItem) {
        const submenu = siteMenuItem.childItems;
        const menuItem = submenu.find((menu) => menu.url === `/${slug}/`);
        const idx = submenu.indexOf(menuItem);
        if (idx >= 1) {
          prevUrl = submenu[idx - 1].url;
        } else {
          // Existing behavior is to link the chapter page
          if (get(store.state, "chapter.current")) {
            prevUrl = `/${chapter.slug}`;
          }
        }
        if (idx >= 0 && idx < submenu.length - 1) {
          const nextMenu = submenu[idx + 1];
          if (nextMenu) {
            nextUrl = nextMenu.url;
          }
        } else {
          // Existing behavior is to link the chapter page
          if (get(store.state, "chapter.current")) {
            nextUrl = `/${store.state.chapter.current.slug}`;
          }
        }
      }
      store.commit("chapter/setPrevPage", prevUrl);
      store.commit("chapter/setNextPage", nextUrl);
    } catch (e) {
      error({ statusCode: 404, message: "Page not found" });
    }
  },

  head() {
    if (this.page && this.page.title) {
      return {
        title: `White-tailed Deer Illinois: ${this.page.title}`,
      };
    }
    return {
      title: `White-tailed Deer Illinois`,
    };
  },

  computed: {
    pageContent() {
      const page = this.$store.state.chapter.insidePage;
      if (page && page.content) {
        const host = this.$axios.defaults.baseURL;
        const { content } = page;
        const fixedURLs = content.replace(
          /https:\/\/wtdi-wp\.wildlifeillinois\.org/g,
          host
        );
        return fixedURLs;
      }
      return "";
    },
    pageTitle() {
      const page = this.$store.state.chapter.insidePage;
      if (page && page.title) {
        return page.title;
      }
      return "";
    },
    parentSlug() {
      const page = this.$store.state.chapter.insidePage;
      if (page && get(page, "parent.slug")) {
        const slug = page.parent.slug;
        const unslug = slug.replace(new RegExp("-", "g"), " ");
        return unslug;
      }
      return "";
    },
    parentLink() {
      const page = this.$store.state.chapter.insidePage;
      if (page && get(page, "parent.uri")) {
        return page.parent.uri;
      }
      return "";
    },
  },

  created() {
    console.log("_chap _.vue run");
    this.slug = `${
      this.$route.params.chap
    }/${this.$route.params.pathMatch.slice(0, -1)}`;
  },

  mounted() {
    this.$nextTick(function () {
      PopoutUtilities.attachPopoutListener();
    });
  },
};
</script>

<style scoped></style>
